import React from 'react'
import { Placeholder } from '..'
import { ArticleList, ArticleTemplate, PagePost, RichText } from '../..'

const Components = {
  'article': ArticleTemplate,
  'article_list': ArticleList,
  'pagepost': PagePost,
  'rich_text': RichText,
}

const DynamicComponent = ({blok, tag_list}) => {
  if(typeof Components[blok.component] !== 'undefined') {
    const Component = Components[blok.component]
    return <Component tag_list={tag_list} blok={blok} key={blok._uid} />
  }
  return blok.component ? <Placeholder componentName={blok.component} /> : null
}

export default DynamicComponent